import { render, staticRenderFns } from "./ChannelIdEdit.vue?vue&type=template&id=cec59b54"
import script from "./ChannelIdEdit.vue?vue&type=script&lang=js"
export * from "./ChannelIdEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports